import {useOpenedStateManager} from '@aboutyou/opened-state-manager';

const SIZE_REMINDER_POPUP_KEY = 'size-reminder-pop-up';

export const useSizeReminderPopupOpenedState = () => {
  return useOpenedStateManager(SIZE_REMINDER_POPUP_KEY);
};
